import { Button, ButtonGroup } from 'react-bootstrap'
import s from './segmented-control.module.scss'

interface SegmentedControlProps {
  options: { label: string; value: string; description?: string }[]
  value: string
  name?: string
  disabled?: boolean
  onClick: (value: string) => void
}

const SegmentedControl = (props: SegmentedControlProps) => {
  const { options, value, name, disabled, onClick } = props

  if (!Array.isArray(options)) {
    return null
  }

  const selectedOption = options.find(opt => opt.value === value)

  return (
    <div>
      <ButtonGroup key={value}>
        {options.map(({ label: optionLabel, value: optionValue }) => (
          <Button
            key={optionValue}
            name={name}
            variant="outline-secondary"
            active={value === optionValue}
            onClick={() => onClick(optionValue)}
            disabled={disabled}
          >
            {optionLabel}
          </Button>
        ))}
      </ButtonGroup>

      {selectedOption?.description && <div className={s.description}>{selectedOption.description}</div>}
    </div>
  )
}

export default SegmentedControl
